import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { tv } from 'tailwind-variants';
// Local
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const phKeyMedium = `custom-container-medium-${props?.params?.DynamicPlaceholderId || 'container-center-75'}`;
    const { container, content } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("div", {
        className: container(),
        ...getTestProps(`component-container-center-75-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: content(),
            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: phKeyMedium,
                rendering: props?.rendering
            })
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'py-layout-base-margin-y',
            'md:flex-row',
            'md:py-component-section-container-padding-y',
            'justify-center'
        ],
        content: [
            'w-full',
            'grid',
            'grid-cols-1',
            'gap-layout-base-margin-none',
            'md:max-w-layout-container-center70-max-width'
        ]
    }
});
